module.exports = __webpack_public_path__ + "static/media/halloween2.ae55a57f.jpg";